import { LocalLink as Link } from '@/lib/locale';
import { ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { categoryBg, categoryName } from '@/lib/catalog';
import { track } from '@/lib/analytics';

export const CategoryTiles = ({ categories }) => {
  const { t, i18n } = useTranslation();
  if (categories.length === 0) return null;

  return (
    <section id="categories" aria-labelledby="categories-title" className="mx-auto max-w-content px-4 pb-10 pt-14 md:px-6 md:pt-20" data-testid="categories-section">
      <h2 id="categories-title" className="text-center font-heading text-[clamp(32px,4vw,56px)] font-extrabold leading-none tracking-[-0.035em]">
        {t('categories.title')}
      </h2>
      <p className="mt-2.5 text-center text-candy-ink-muted">{t('categories.subtitle')}</p>

      <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
        {categories.map((cat, i) => (
          <Link
            key={cat.category_id}
            to={`/category/${cat.slug}`}
            onClick={() => track('select_category', { category_id: cat.category_id })}
            data-testid={`category-card-${cat.slug}`}
            className={`group flex min-h-[200px] flex-col justify-between rounded-card p-7 text-candy-ink ${categoryBg(i)}`}
          >
            <span className="self-start rounded-full bg-candy-surface px-3 py-1.5 text-[13px] font-bold">
              {t('categories.count', { count: cat.product_count ?? 0 })}
            </span>
            <span className="flex items-end justify-between gap-3">
              <span className="font-heading text-[28px] font-extrabold leading-[1.05] tracking-[-0.02em]">{categoryName(cat, i18n.language)}</span>
              <span className="grid h-[46px] w-[46px] flex-none place-items-center rounded-full bg-candy-ink text-white transition-transform duration-200 ease-out group-hover:translate-x-1">
                <ArrowRight className="h-[18px] w-[18px]" strokeWidth={2.4} aria-hidden="true" />
              </span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
};
